import React, { FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Icons, PageTitle, PageTitleIconPrefix, PublicPageWrapper } from '../../shared/components';
import { usePublicPageSettings } from '../../shared/hooks';
import { LoginForm } from '../components';
import Cookies from 'js-cookie';

var _hsq = (window._hsq = window._hsq || []);
const env = process.env.REACT_APP_ENVIRONMENT;

const LoginPage: FC = () => {
  const { t } = useTranslation();
  const [, setPublicPageSettings] = usePublicPageSettings();

  useEffect(() => {
    setPublicPageSettings({ pageWidth: '42rem' });
  }, [setPublicPageSettings]);

  useEffect(() => {
    // Clear cookie tracking
    _hsq.push(['setPath', 'logout']);
    _hsq.push(['trackPageView']);
    _hsq.push(['refreshPageHandlers']);

    //remove cookie hubspotutk
    if (env !== 'demo') {
      Cookies.remove('hubspotutk');
      Cookies.remove('hubspotutk', { path: '/', domain: '.lernova.be' });
    }

    // Set chatbot to not start before id
    window.hsConversationsSettings = {
      loadImmediately: true,
    };
    // Reset chatbot so it dont get from ex logged in user
    window?.HubSpotConversations?.clear({ resetWidget: true });
  }, []);

  const hubSpotCookieId = useMemo(() => {
    return Cookies.get('hubspotutk');
  }, []);

  useEffect(() => {
    if (hubSpotCookieId && env !== 'demo') {
      Cookies.remove('hubspotutk');
      Cookies.remove('hubspotutk', { path: '/', domain: '.lernova.be' });
    }
  }, [hubSpotCookieId]);

  const script = document.getElementById('hs-script-loader');

  useEffect(() => {
    if (script && script?.parentNode && env !== 'demo') {
      script.parentNode.removeChild(script);
    }
  }, [script]);

  return (
    <PublicPageWrapper>
      <PageTitle prefix={<PageTitleIconPrefix icon={Icons.USER} />}>
        {t('security.login.pageTitle')}
      </PageTitle>
      <LoginForm />
    </PublicPageWrapper>
  );
};

export default LoginPage;
